import { render, staticRenderFns } from "./setup-wizard.vue?vue&type=template&id=076ca9c0&scoped=true&"
import script from "./setup-wizard.vue?vue&type=script&lang=js&"
export * from "./setup-wizard.vue?vue&type=script&lang=js&"
import style0 from "./setup-wizard.vue?vue&type=style&index=0&id=076ca9c0&lang=scss&scoped=true&"
import style1 from "./setup-wizard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ca9c0",
  null
  
)

export default component.exports